import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OmpMoments, OmpPages, ompMomentsForPage, ompPageHasMoments } from '../order-management-portal.sections';
import { OmpDevicePreview, OmpMoment, OmpPage, OmpTab } from '../../_models';

@Component({
  selector: 'app-omp-header',
  templateUrl: './omp-header.component.html',
  styleUrls: ['./omp-header.component.scss'],
})
export class OmpHeaderComponent {
  @Input() activeTab: OmpTab = OmpTab.Sections;
  @Output() tabChange = new EventEmitter<OmpTab>();
  public ompTab = OmpTab;

  public pages = OmpPages;
  @Input() selectedMoment: OmpMoment = OmpMoment.None;
  @Input() selectedPage: OmpPage = OmpPage.Home;
  @Input() activeDevice: OmpDevicePreview = OmpDevicePreview.Desktop;
  @Input() canSave = false;
  @Input() saveIssues: string[] = [];
  @Input() navigationEnabled = false;
  @Input() canUndo = false;
  @Input() canRedo = false;
  @Input() undoLabel = '';
  @Input() redoLabel = '';
  @Input() hasChanges = false;
  @Input() saving = false;
  @Output() navigationToggle = new EventEmitter<boolean>();
  public showSaveIssues = false;
  public moreOpen = false;
  private shortcutKey = /Mac|iPhone|iPad/.test(navigator.userAgent) ? '⌘' : 'Ctrl+';

  @Output() momentChange = new EventEmitter<OmpMoment>();
  @Output() pageChange = new EventEmitter<OmpPage>();
  @Output() deviceChange = new EventEmitter<OmpDevicePreview>();
  @Output() reset = new EventEmitter<void>();
  @Output() undo = new EventEmitter<void>();
  @Output() redo = new EventEmitter<void>();
  @Output() save = new EventEmitter<void>();
  @Output() livePreview = new EventEmitter<void>();

  public devicePreview = OmpDevicePreview;

  selectTab(tab: OmpTab) {
    this.activeTab = tab;
    this.tabChange.emit(tab);
  }

  isTabActive(tab: OmpTab) {
    let active = false;
    if (this.activeTab === tab) {
      active = true;
    }
    return active;
  }

  onMomentChange(moment: OmpMoment) {
    this.selectedMoment = moment;
    this.momentChange.emit(moment);
  }

  get showMoments(): boolean {
    return ompPageHasMoments(this.selectedPage);
  }

  get moments() {
    const allowed = ompMomentsForPage(this.selectedPage);
    return OmpMoments.filter((m) => allowed.indexOf(m.key) >= 0);
  }

  get selectedMomentLabel() {
    let label = '';
    const match = this.moments.filter((m) => m.key === this.selectedMoment);
    if (match.length) {
      label = match[0].label;
    }
    return label;
  }

  onPageChange(page: OmpPage) {
    this.selectedPage = page;
    this.pageChange.emit(page);
  }

  get selectedPageLabel() {
    let label = '';
    const match = this.pages.filter((p) => p.key === this.selectedPage);
    if (match.length) {
      label = match[0].label;
    }
    return label;
  }

  selectDevice(device: OmpDevicePreview) {
    this.activeDevice = device;
    this.deviceChange.emit(device);
  }

  isDeviceActive(device: OmpDevicePreview) {
    let active = false;
    if (this.activeDevice === device) {
      active = true;
    }
    return active;
  }

  onNavigationToggle(enabled: boolean) {
    this.navigationEnabled = enabled;
    this.navigationToggle.emit(enabled);
  }

  get undoTitle(): string {
    let title = 'Nothing to undo';
    if (this.canUndo) {
      title = 'Undo ' + this.undoLabel + ' (' + this.shortcutKey + 'Z)';
    }
    return title;
  }

  get redoTitle(): string {
    let title = 'Nothing to redo';
    if (this.canRedo) {
      title = 'Redo ' + this.redoLabel + ' (' + this.shortcutKey + 'Shift+Z)';
    }
    return title;
  }

  onUndo() {
    this.undo.emit();
  }

  onRedo() {
    this.redo.emit();
  }

  onReset() {
    this.moreOpen = false;
    this.reset.emit();
  }

  onSave() {
    this.save.emit();
  }

  onLivePreview() {
    this.livePreview.emit();
  }
}
